/* line-properties.js — SOP vendor line-item property injector */
(function () {
  var DEBUG = !!window.SOP_VENDOR_LINEPROPS_DEBUG;
  /** Log diagnostic details only when vendor-property debugging is enabled. */
  function log() { if (DEBUG) console.log.apply(console, ["[line-props]"].concat([].slice.call(arguments))); }
  /** Report a failed property update without interrupting the cart UI. */
  function warn() { console.warn.apply(console, ["[line-props]"].concat([].slice.call(arguments))); }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
  /** Resolve an endpoint relative to the localized storefront root. */
  function url(p) { return ROOT + String(p).replace(/^\//, ""); }

  var PROP_KEY = "Vendor";
  var ESTIMATED_SHIP_PROP_KEY = "Estimated to ship on or by";
  var running = false;
  var queued = false;

  // Matches /cart/add, /cart/add.js, /cart/change.js, etc.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  /** Fetch the current cart snapshot with line keys and properties. */
  async function fetchCart() {
    var res = await window.fetch(url("cart.js"), { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed (" + res.status + ")");
    return res.json();
  }

  /** Replace line properties by stable key while preserving quantity. */
  async function changeLine(key, quantity, properties) {
    var res = await window.fetch(url("cart/change.js?_bogos-ignore"), {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity, properties: properties })
    });

    var data;
    try { data = await res.json(); } catch (e) { data = null; }
    if (!res.ok) throw new Error("cart/change.js failed (" + res.status + ")");
    return data;
  }

  /** Preserve product vendors, remove gift-box vendors, and serialize overlapping updates. */
  async function ensureVendorProperties() {
    if (running) { queued = true; return; }
    running = true;

    try {
      var cart = await fetchCart();
      var items = Array.isArray(cart.items) ? cart.items : [];

      log("cart items:", items.length);

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var isGiftWrap = window.SOPGiftWrap?.isGift(item);
        var vendor = isGiftWrap ? "" : (item.vendor || "");
        if (!vendor && !isGiftWrap) continue;

        var props = (item.properties && typeof item.properties === "object") ? item.properties : {};

        var nextProps = Object.assign({}, props);
        var hasEstimatedShipProperty = Object.prototype.hasOwnProperty.call(nextProps, ESTIMATED_SHIP_PROP_KEY);
        var estimatedShipValue = nextProps[ESTIMATED_SHIP_PROP_KEY];
        var hasBlankEstimatedShipValue = hasEstimatedShipProperty && String(estimatedShipValue || "").trim() === "";

        if (hasBlankEstimatedShipValue) {
          delete nextProps[ESTIMATED_SHIP_PROP_KEY];
        }

        if (isGiftWrap) {
          if (!Object.prototype.hasOwnProperty.call(nextProps, PROP_KEY) && !hasBlankEstimatedShipValue) continue;
          delete nextProps[PROP_KEY];
          // Shopify cannot clear properties with an empty object. Keep a private marker.
          nextProps._sop_gift_box = 'true';
        } else {
          if (nextProps[PROP_KEY] === vendor && !hasBlankEstimatedShipValue) continue;
          nextProps[PROP_KEY] = vendor;
        }

        log("setting vendor on line", i + 1, "=>", vendor);

        try {
          await changeLine(item.key, item.quantity, nextProps);
        } catch (e) {
          warn("failed to set Vendor on line " + (i + 1), e);
        }
      }
    } catch (e) {
      warn("ensureVendorProperties failed", e);
    } finally {
      running = false;
      if (queued) {
        queued = false;
        setTimeout(ensureVendorProperties, 0);
      }
    }
  }

  // Debounced schedule (collapses bursts)
  var scheduled = false;
  /** Coalesce cart notifications into one deferred property reconciliation. */
  function scheduleEnsure(reason) {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      log("running ensure (reason:", reason + ")");
      ensureVendorProperties();
    }, 0);
  }

  // 1) Run on load (covers existing carts, and cases where add-to-cart happens before listeners are ready)
  document.addEventListener("DOMContentLoaded", function () { scheduleEnsure("DOMContentLoaded"); });
  window.addEventListener("pageshow", function () { scheduleEnsure("pageshow"); });

  // 2) If theme dispatches an event, use it
  document.addEventListener("theme:cart-add", function () { scheduleEnsure("theme:cart-add"); });

  // 3) Hook fetch robustly — even if an app overwrites fetch after this script runs
  /** Wrap fetch so completed cart mutations schedule property reconciliation. */
  function wrapFetch(fn) {
    if (typeof fn !== "function") return fn;
    if (fn.__linePropsWrapped) return fn;

    /** Forward fetch and schedule reconciliation after cart requests settle. */
    function wrapped(input, init) {
      var reqUrl = "";
      try { reqUrl = (typeof input === "string") ? input : (input && input.url) ? input.url : ""; } catch (e) {}

      var p = fn.apply(this, arguments);

      // If it's a Promise-like, schedule after it settles.
      if (p && typeof p.then === "function" && CART_RE.test(reqUrl)) {
        return p.then(function (res) {
          scheduleEnsure("fetch:" + reqUrl);
          return res;
        }, function (err) {
          scheduleEnsure("fetch-error:" + reqUrl);
          throw err;
        });
      }

      return p;
    }

    wrapped.__linePropsWrapped = true;
    return wrapped;
  }

  // Install a setter so later scripts that overwrite fetch still get wrapped
  (function installFetchHook() {
    try {
      var current = wrapFetch(window.fetch);
      Object.defineProperty(window, "fetch", {
        configurable: true,
        get: function () { return current; },
        set: function (next) { current = wrapFetch(next); }
      });
      // re-assign to trigger setter/wrapping
      window.fetch = current;
      log("fetch hook installed");
    } catch (e) {
      // Fallback: best-effort direct wrap
      window.fetch = wrapFetch(window.fetch);
      log("fetch hook fallback installed");
    }
  })();

  // 4) Hook XHR too (some apps use it)
  (function installXHRHook() {
    if (!window.XMLHttpRequest) return;

    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, requestUrl) {
      this.__linePropsUrl = requestUrl || "";
      return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      try {
        if (this.__linePropsUrl && CART_RE.test(String(this.__linePropsUrl))) {
          this.addEventListener("loadend", function () {
            scheduleEnsure("xhr:" + this.__linePropsUrl);
          });
        }
      } catch (e) {}
      return send.apply(this, arguments);
    };

    log("xhr hook installed");
  })();

  // Manual test helper
  window.SOP_ensureVendorProperties = ensureVendorProperties;

  log("line-properties.js loaded");
})();
